import MarketplaceItemProductRating from './MarketplaceItemProductRating'

export default MarketplaceItemProductRating
